import React from 'react';
import PropTypes from 'prop-types';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { withStyles, Grid, Avatar, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { keyEmptyCheck } from 'aurora-utils/utils';
import { ADGMPanel } from 'aurora-components';
import styles from './styles';
import PrimaryContactLessorInformation from './PrimaryContactLessorInformation';

const PrimaryLessorInformation = props => {
  const { classes, application, locale } = props;

  const getPrimaryLessor = () => {
    if (application?.primaryLessor) {
      if (Array.isArray(application?.primaryLessor)) return application?.primaryLessor;
      return [application?.primaryLessor];
    }

    return application?.owners || [];
  };
  const primaryLessors = getPrimaryLessor();
  return (
    <>
      <ADGMPanel // className={classes.accordianFrame}
        // style={{ order: panel?.order }}
        // id={panel?.id}
        // order={panel?.order}
        title={keyEmptyCheck('lessor_details')}
        customClasses={{ container: classes.marginTopOnSm }}
      >
        {/* <Grid className={classes.accTitleHead}>
          <Typography className={classes.heading}>
            <FormattedMessage {...messages.lessor_details} />
          </Typography>
        </Grid> */}
        <Grid className={classNames(classes.accordionDetails, classes.lessorContainer)}>
          <Grid container spacing={3}>
            {primaryLessors.map(item => {
              return (
                <Grid container className={classes.boxBackground} spacing={3}>
                  <Grid item xs={12} md={4} className={classNames(classes.flexCenter, classes.lessorGrid)}>
                    <Grid>
                      <Avatar
                        alt='lessor'
                        src={item?.tradeLicenseNumber ? '/images/company_profile.svg' : '/images/avatar_profile.svg'}
                        className={classes.ownerAvatarimg}
                      />
                    </Grid>
                    <div className={classes.nameDiscription}>
                      <Typography variant='body1' className={classNames(classes.lightWeightLable)}>
                        {keyEmptyCheck('Name')}
                      </Typography>
                      <Typography variant='body1' className={classNames(classes.lightWeightValue)}>
                        {locale === 'ar' ? item?.nameAr || item?.ownerNameAr : item?.name || item?.ownerNameEn}
                      </Typography>
                    </div>
                  </Grid>
                  {item?.tradeLicenseNumber ? (
                    <Grid item xs={12} md={2} className={classes.lessorGrid}>
                      <ADGMItemDetails
                        label='commercial_license_no'
                        value={item?.tradeLicenseNumber ? item?.tradeLicenseNumber : '-'}
                        labelClass={classes.lightWeightLable}
                        valueClass={classes.lightWeightValue}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={12} md={2} className={classes.lessorGrid} spacing={3}>
                      <ADGMItemDetails
                        label='eid'
                        value={item?.lessorId || item?.eidOrUnified}
                        labelClass={classes.lightWeightLable}
                        valueClass={classes.lightWeightValue}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} md={2} className={classes.lessorGrid}>
                    <ADGMItemDetails
                      label='phone_number'
                      value={item?.mobileNumber || item?.phoneNumber}
                      labelClass={classes.lightWeightLable}
                      valueClass={classes.lightWeightValue}
                    />
                  </Grid>
                  <Grid item xs={12} md={2} className={classes.lessorGrid}>
                    <ADGMItemDetails
                      label='email'
                      value={item?.email}
                      labelClass={classes.lightWeightLable}
                      valueClass={classes.lightWeightValue}
                    />
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </ADGMPanel>
      <PrimaryContactLessorInformation classes={classes} locale={locale} primaryContact={application?.primaryContact} />
    </>
  );
};
PrimaryLessorInformation.propTypes = {
  classes: PropTypes.object.isRequired,
  application: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
};
export default withStyles(styles)(PrimaryLessorInformation);
